import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Availability = () => {
  
  const [date, setdate] = useState("")
  const [startTime, setstarttime] = useState("")
  const [endTime, setendtime] = useState("")
  const [alltimes, setalltimes] = useState([])
  const navigate = useNavigate();



  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("https://api.kgphotographies.com/api/addtime", {
        date,
        startTime,
        endTime,
      }, { withCredentials: true })
      .then((res) => {
        alert("time Added")
        console.log(res);
      })
      .catch((err) => {
        alert("failed to add time")
        console.log(err.response.data.err)
      });
  };

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(
          "https://api.kgphotographies.com/api/protected-route",
          {
            withCredentials: true,
          }
        );
        console.log(response.data)
        // Continue with normal flow if the session is active
      } catch (error) {
        // Redirect to login page or handle the situation accordingly
        navigate("/login");
      }
    };

    checkSession();
  }, [navigate]);

  const logouthandler = (e) => {
    e.preventDefault();
    axios
        .get("https://api.kgphotographies.com/api/logout", {
        }, { withCredentials: true })
        .then((res) => {
        console.log(res);
        navigate('/')
        })
        .catch((err) => {
        console.log(err)
        });
    };

    useEffect(() => {
      axios
      .get(`https://api.kgphotographies.com/api/getalltimes`)
          .then((res) => {
          
          console.log(res.data)
          setalltimes(res.data)
          })
          .catch((err) => {
          console.log(err.response);
          });
  }, []);


    return (
      <div>
  <header>
    <ul className="nav nav-pills nav-justified mb-3" id="ex1" role="tablist">
    <li className="nav-item" role="presentation">
      <a className="nav-link" id="tab-photo" data-mdb-toggle="pill" href="/Addphoto" role="tab"
        aria-controls="pills-photo" aria-selected="false">Add Photo</a>
    </li>
    <li className="nav-item" role="presentation">
      <a className="nav-link active" id="tab-time" data-mdb-toggle="pill" href="/availability" role="tab"
        aria-controls="pills-time" aria-selected="true">Add Availability</a>
    </li>
  </ul>
  </header>
        <form onSubmit={handleSubmit}>
          <div>
            <div className="form-label">
              <label>
                date
                <input
                  className="form-control"
                  onChange={(e) => setdate(e.target.value)}
                  value={date}
                  name="date"
                  type="date"
                />
              </label>
            </div>
  
  
            <div className="form-fields">
              <label>
                Start Time:
                <input
                  className="form-control"
                  onChange={(e) => setstarttime(e.target.value)}
                  value={startTime}
                  name="startTime"
                  type="time"
                  required
                />
              </label>
            </div>
  
            <div className='form-fields'>
              <label>
                End Time:
              <input
                  className="form-control"
                  onChange={(e) => setendtime(e.target.value)}
                  value={endTime}
                  name="endTime"
                  type="time"
                  required
                />
                </label>
            </div>
  
            <button className="btn btn-info mt-3" type="submit">
              Accept
            </button>
            <div className="mt-3 me-3">
              <button className="btn btn-secondary" onClick={logouthandler}>Back</button>
            </div>
          </div>
        </form>
        <div>
        <ul>
          {alltimes.map((time) => (
            <li key={time.id}>{new Date(time.date).toLocaleDateString()} {time.startTime} - {time.endTime}</li>
          ))}
        </ul>
        </div>
      </div>
    );

}

export default Availability;